import { site } from "@/data/site";

// Builds a WhatsApp enquiry message, auto-prefilled with the project name.
export const buildEnquiry = (projectName, intent = "general") => {
    const base = projectName
        ? `Hello Swastik Realty,\nI'm interested in ${projectName}.\n`
        : "Hello Swastik Realty,\n";
    const map = {
        general: projectName
            ? `${base}Please share the brochure, floor plans, latest price sheet and help me schedule a site visit.`
            : "Hello Swastik Realty, I'd like to enquire about luxury residences in Mumbai.",
        brochure: `${base}Please share the brochure for ${projectName || "your residences"}.`,
        floorplan: `${base}Please share the floor plans for ${projectName || "your residences"}.`,
        pricesheet: `${base}Please share the latest price sheet for ${projectName || "your residences"}.`,
        sitevisit: `${base}I'd like to book a site visit for ${projectName || "a residence"}. Please help me schedule.`,
    };
    return map[intent] || map.general;
};

export const waUrl = (text) =>
    `https://wa.me/${site.contact.whatsapp}?text=${encodeURIComponent(text)}`;

export const telUrl = `tel:${site.contact.phone}`;
export const mailUrl = `mailto:${site.contact.email}`;
